import { useQuery } from 'react-query'

import { scanService } from 'src/services/scan.service'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'

export const initialScansFilter = {
  query: '',
  accountsIds: ['all'],
  status: ['all'],
  geofence: ['all'],
  scan_type: ['all'],
  own: false,
}

export const useScans = (filter: IFilter) => {
  return useQuery(
    [QUERY_KEYS.SCANS, filter],
    () => scanService.getScans(removeDefaultParams(filter, initialScansFilter)),
    {
      keepPreviousData: true,
    },
  )
}
